import emptyCadastroBase from './emptyCadastroBase'

export default {
  ...emptyCadastroBase,
  tipo: {
    codigo: 'NAO_ONEROSO'
  },
  json: {
    tipo: null,
    dados: {
      cadastro: {
        id: null,
        hash: null,
        tipo: null,
        codigo: null,
        imovel: {
          id: null,
          area: null,
          nome: null,
          termo: null,
          conflitos: null,
          municipio: null,
          possuiCar: null,
          areaTitulo: null,
          documentos: null,
          numeroLote: null,
          denominacao: null,
          finalidades: null,
          localizacao: null,
          nomeColonia: null,
          cnsMatricula: null,
          numeroTitulo: null,
          possuiImovel: null,
          tempoOcupacao: null,
          livroMatricula: null,
          descricaoAcesso: null,
          municipioTitulo: null,
          numeroMatricula: null,
          numeroReciboCar: null,
          modalidadeTitulo: null,
          dataExpedicaoTitulo: null,
          destinacaoUsoImovel: null,
          ocupantesAnteriores: null,
          numeroFolhaMatricula: null,
          nomeBeneficiarioTitulo: null,
          numeroProcessoJudicial: null,
          solicitarResgateAforamento: null,
          causasImpossibilidadeOcupacao: null
        },
        situacao: null,
        protocolo: null,
        dataUpload: null,
        cadastrante: {
          id: null,
          tipo: null,
          pessoa: {
            id: null,
            tipo: null,
            ativo: null,
            email: null,
            usuario: null,
            cpfCnpj: null,
            nomeRazaoSocial: null,
            endereco: {
              id: null,
              cep: null,
              bairro: null,
              numero: null,
              municipio: {
                id: null,
                mf: null,
                nome: null,
                regiao: null,
                codigoEstado: null,
                valorReferencia: null
              },
              semNumero: null,
              logradouro: null,
              complemento: null
            },
            telefones: [],
            dataCadastro: null,
            pessoaFisica: {
              id: null,
              rg: null,
              cpf: null,
              nome: null,
              matricula: null,
              nomeDaMae: null,
              estadoCivil: null,
              naturalidade: null,
              nacionalidade: null,
              dataNascimento: null,
              orgaoExpedidor: null,
              temCertidaoObito: null
            },
            isPessoaFisica: null,
            pessoaJuridica: null
          },
          despacho: null,
          documentos: null,
          representantes: null,
          membrosComunidade: null
        },
        interessado: {
          id: null,
          pessoa: {
            id: null,
            tipo: null,
            ativo: null,
            email: null,
            usuario: null,
            endereco: {
              id: null,
              cep: null,
              bairro: null,
              numero: null,
              municipio: {
                id: null,
                mf: null,
                nome: null,
                regiao: null,
                codigoEstado: null,
                valorReferencia: null
              },
              semNumero: null,
              logradouro: null,
              complemento: null
            },
            telefones: [],
            dataCadastro: null,
            pessoaFisica: {
              id: null,
              rg: null,
              cpf: null,
              nome: null,
              matricula: null,
              nomeDaMae: null,
              estadoCivil: null,
              naturalidade: {
                id: null,
                mf: null,
                nome: null,
                regiao: null,
                codigoEstado: null,
                valorReferencia: null
              },
              nacionalidade: null,
              dataNascimento: null,
              orgaoExpedidor: {
                id: null,
                nome: null,
                codigo: null,
                estado: null,
                nomeEstado: null
              },
              temCertidaoObito: null
            },
            isPessoaFisica: null,
            pessoaJuridica: null
          },
          conjuge: null,
          espolio: null,
          prefeito: null,
          documentos: [],
          sociosRepresentantesLegais: null
        },
        solicitacao: null,
        dataCadastro: null,
        qualificacao: {
          id: null,
          area: null,
          gleba: null,
          renda: null,
          ocupaImovel: null,
          cargoPublico: null,
          pagoIntegral: null,
          areaMatriculada: null,
          pertenceAoProjeto: null,
          exploracaoAgricola: null,
          areaGeorreferenciada: null,
          beneficiarioOriginal: null,
          beneficiarioOriginario: null,
          possuiImovelRuralTitulado: null
        },
        beneficiarios: null,
        caminhoSicarf: null,
        dataAtualizacao: null,
        informacaoDesejada: null,
        destinacaoUsoImovel: {
          outros: null,
          abaAtiva: '',
          pecuaria: null,
          semovente: {
            area: null,
            tipo: '',
            descricao: '',
            numeroCabecas: ''
          },
          edificacao: {
            area: null,
            tipo: '',
            funcao: '',
            descricao: null,
            unidadeArea: ''
          },
          semoventes: [],
          agricultura: null,
          edificacoes: [],
          silvicultura: null,
          produtividade: {
            dap: '',
            drp: '',
            tipo: '',
            documentos: [],
            possuiComprovante: null,
            documentosRemovidos: []
          },
          outraAtividade: {
            area: null,
            tipo: '',
            descricao: '',
            observacoes: ''
          },
          silviculturaObj: {
            area: null,
            especie: '',
            descricao: '',
            produtividade: ''
          },
          outrasAtividades: [],
          culturaPermanente: {
            area: null,
            tipo: '',
            descricao: ''
          },
          culturaTemporaria: {
            area: null,
            tipo: '',
            descricao: ''
          },
          servidaoAmbiental: false,
          manejoFlorestalObj: {
            area: null,
            descricao: '',
            produtividade: '',
            numeroLicencaPMFS: ''
          },
          possuiReservaLegal: null,
          culturasPermanentes: [],
          culturasTemporarias: [],
          sistemasAgroflorestais: null
        },
        georreferenciamento: {
          documentos: [],
          denominacao: '',
          responsavel: {
            nome: '',
            creaRnp: '',
            formacao: '',
            codigoIncra: ''
          },
          jsonPlanilha: '',
          localizacoes: [],
          tipoPlanilha: '',
          documentosRemovidos: [],
          possuiGeorreferenciamento: ''
        },
        isAceiteTermoDeCompromisso: true
      }
    },
    versao: null
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/para/empty/emptyNaoOneroso.js